<template>
  <div class="tw-relative">
    <history-common
      :tier="tierType"
      :tier_id="selectedCustomer.id"
      class="tw-mb-6"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import HistoryCommon from "@/views/Common/History";

import { TIER } from "@/constants";

export default {
  components: {
    HistoryCommon,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },

  async mounted() {
    this.setPageTitle(this.$t("History"));
    this.setPageSubtitle([
      this.$t(
        "Search and view recent messages for your domains to troubleshoot in realtime"
      ),
    ]);
    if (!this.selectedCustomer) {
      this.$router.push("/logout");
    }
  },
};
</script>
